"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderLineClientModel = void 0;
var OrderLineClientModel = /** @class */ (function () {
    function OrderLineClientModel(serverModel) {
        this.id = serverModel.id;
        this.sku = serverModel.sku;
        this.quantity = serverModel.quantity;
        this.status = serverModel.status;
        this.ref = serverModel.item_ref;
        this.order_line_print = serverModel.order_line_print;
    }
    return OrderLineClientModel;
}());
exports.OrderLineClientModel = OrderLineClientModel;
